import { logError } from './error-logger';
import config from './load-config';
import mem from 'mem';

export const trimTrailingSlash = (url: string) => url.replace(/\/$/, '');

export const trimUrl = (url: string) =>
  trimTrailingSlash(url.replace(/\s/g, ''));

export const canonicalUrl = mem((path: string) => {
  try {
    const url = new URL(path, config.site.url);

    url.search = '';
    url.hash = '';

    return trimTrailingSlash(url.toString());
  } catch (e) {
    logError(e, 'canonicalUrl');
  }

  return undefined;
});

export const isValidUrl = (url: string) => {
  const pattern = /^https?:\/\/([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/;
  return pattern.test(url);
};

/**
 * Although query params allow multiple we consistently use a single value.
 * The types however still support the standard API of passing an array.
 * For our usages though if that were ever to happen we'd want the first value anyway.
 */
export const stringifyQueryParam = (param?: string | string[]) =>
  Array.isArray(param) ? param.find(Boolean) : param;
